var LayoutPerspective = require('./../layout/LayoutPerspective');
var settingsLayoutTemplate = require('./patientSettingsLayoutTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var PatientSettingsView = require('./PatientSettingsView');

/**
 * Perspective for the patient-portal settings
 *
 * @class PatientSettingsView
 */
module.exports = LayoutPerspective.extend({
  template: settingsLayoutTemplate,
  moduleNamespace: 'patientSettingsPerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: PortalPerspectiveLayoutBehavior,
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'patient.settings.aside.header',
      asideContentMessageKey: 'patient.settings.aside.content'
    }
  },

  injectionSites: {
    'settings-view': '_settingsView'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to render the data for.
   */
  initialize: function(options) {
    var patientVecnaId = options.patientVecnaId;
    this._settingsView = new PatientSettingsView({
      patientVecnaId: patientVecnaId
    });
  }
});
